import { BomType } from "../models/bg.model";

export class BgModelHelper{
  static isEqual(bomType: BomType | undefined, value: string): boolean {
    if (bomType === undefined || !value) {
      return false;
    }

    // Convert backend string ("Addon") → enum number (2)
    const enumValue = BomType[value as keyof typeof BomType];

    // If backend sent invalid value
    if (enumValue === undefined) {
      return false;
    }

    return bomType === enumValue;
  }
}
